import { render, staticRenderFns } from "./EventPublication.vue?vue&type=template&id=18d56e13&"
import script from "./EventPublication.vue?vue&type=script&lang=js&"
export * from "./EventPublication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports